import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';
import {Body} from 'shells/typography/body';

type Props = {
    startTime: number;
    endTime: number;
};

export function ActivityRowBottomSection(props: Props) {
    const currentTime = Date.now() / 1000;

    return (
        <StackLegacy isHorizontal={true} spacing={8}>
            <Body color={currentTime < props.endTime ? 'light' : 'error'} size='small'>
                <FormattedTimestamp
                    datetime={props.startTime}
                    format={FormattedTimestamp.formats.monthDayYear}
                />
            </Body>
            <Body color='light' size='small'>
                <FormattedTimestamp
                    datetime={props.startTime}
                    format={FormattedTimestamp.formats.time}
                />
            </Body>
        </StackLegacy>
    );
}
